import React, { useEffect, useState } from "react";
import MainHeader from "../../shared/MainHeader";
import {
  Box,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  Typography,
  Divider,
} from "@mui/material";
import { GET, POST } from "../../api/ApiService";
import { useDispatch, useSelector } from "react-redux";
import AutocompleteInput from "../../shared/AutocompleteInput";
import EncryptionHelper from "../../shared/EncryptionHelper";
import { storeAllRoles } from "../../slices/allroleSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Permissions = () => {
  const dispatch = useDispatch();
  const allRoles = useSelector((state) => state.allroleReducer.allroles);

  const [permissions, setPermissions] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [selectedRole, setSelectedRole] = useState();

  // Predefined Notifications (based on acceptance criteria)
  const notificationList = [
    { id: "status_change", label: "Notify on Case 'Status' Changed" },
    { id: "billed_change", label: "Notify on Case 'Billed' Changed" },
    { id: "assigned_change", label: "Notify on Case 'Assigned To' Changed" },
    { id: "ready_assign", label: "Notify on Case 'Ready to Assign' Changed" },
    { id: "hours_limit", label: "Notify on Case 'Hours Limit' Changed" },
    { id: "new_case", label: "Notify on New Case Created" },
    {
      id: "supplemental_order_request",
      label: "Notify on Supplemental Order Request Created",
    },
    {
      id: "supplemental_order_update",
      label: "Notify on Supplemental Order Request Updated",
    },
    { id: "adjourn_date_cron", label: "Notify on Adjourn Date Cron Job" },
  ];

  useEffect(() => {
    GET("roles")
      .then((resp) => {
        const encryptedData = resp?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);

        dispatch(storeAllRoles(decryptedData));
      })
      .catch((err) => {
        console.warn("err ==>", err);
      });
  }, []);

  useEffect(() => {
    const dropdownRoles = allRoles?.map((item) => {
      return {
        value: item.RoleID,
        label: item.RoleName,
      };
    });
    setRolesData(dropdownRoles);
  }, [allRoles]);

  useEffect(() => {
    if (selectedRole) {
      getPermissionForRoles();
      getNotificationForRoles();
    }
  }, [selectedRole]);

  const getPermissionForRoles = () => {
    GET(`assigned-permission/${selectedRole?.value}`)
      .then((resp) => {
        const encryptedData = resp?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);

        console.log("decryptedData ---------------------", decryptedData);

        setPermissions(decryptedData || []);
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const getNotificationForRoles = () => {
    GET(`assigned-notification/${selectedRole?.value}`)
      .then((resp) => {
        const encryptedData = resp?.encryptedData;
        const decryptedData = EncryptionHelper.decryptData(encryptedData);

        console.log("decryptedData -------------------->", decryptedData);

        setNotifications(decryptedData || []);
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const switchPermissionHandler = (permissionId) => {
    const postData = {
      role: selectedRole?.value,
      permission: permissionId,
    };

    const encryptData = EncryptionHelper.encryptData(postData);

    POST("assign-permission", { encryptData })
      .then((resp) => {
        getPermissionForRoles();
        toast.success(resp?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const switchNotificationHandler = (notificationId) => {
    const postData = {
      role: selectedRole?.value,
      notification: notificationId,
    };

    const encryptData = EncryptionHelper.encryptData(postData);

    POST("assign-notification", { encryptData })
      .then((resp) => {
        getNotificationForRoles();
        toast.success(resp?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <Box>
      <MainHeader headingText="Permissions" />
      <Stack
        gap={3}
        p={3}
        sx={{
          border: "1px solid #C1C1C1",
          minHeight: "80vh",
        }}
      >
        <Typography variant="h4">
          Assign Permissions & Notifications to Role
        </Typography>

        {/* Role Dropdown */}
        <AutocompleteInput
          name="allroles"
          options={rolesData}
          onChange={(event, newValue) => {
            setSelectedRole(newValue);
          }}
        />

        {/* Permissions + Notifications side by side */}
        {selectedRole && (
          <Stack direction="row" gap={6} mt={3} alignItems="flex-start">
            {/* Permissions Section */}
            <Box flex={1}>
              <Typography variant="h6" mb={2}>
                Permissions
              </Typography>
              <Stack spacing={2}>
                {permissions?.map((item) => (
                  <FormControlLabel
                    key={item.permission_id}
                    control={
                      <Switch
                        size="small"
                        checked={item.status === "1" ? true : false}
                        onChange={() =>
                          switchPermissionHandler(item.permission_id)
                        }
                      />
                    }
                    label={`${item.permission_name} (${item.description})`}
                    labelPlacement="end"
                  />
                ))}
              </Stack>
            </Box>

            {/* Notifications Section */}
            <Box flex={1}>
              <Typography variant="h6" mb={2}>
                Notifications
              </Typography>
              <Stack spacing={2}>
                {notifications?.map((item) => {
                  // const assigned = notifications?.some(
                  //   (n) => n.notification_id === item.id && n.status === "1"
                  // );

                  return (
                    <FormControlLabel
                      key={item?.NotificationID}
                      control={
                        <Switch
                          size="small"
                          checked={item?.status === "1" ? true : false}
                          onChange={() =>
                            switchNotificationHandler(item?.NotificationID)
                          }
                        />
                      }
                      label={item?.NotificationName}
                      labelPlacement="end"
                    />
                  );
                })}
              </Stack>
            </Box>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default Permissions;
